import gql from 'graphql-tag';

export const GET_PROFILE_RECORDS = gql`
  query GetProfile {
    getProfileData {
      firstname
      lastname
      company
      email
      telephone
      howDidYouLearnAboutBuffl
      createdAt
    }
  }
`;

export const GET_PROFILE_ACCOUNT_MANAGEMENT_RECORDS = gql`
  query GetAccountManagementRecords {
    getAccountManagementData {
      name
    }
  }
`;

export const UPDATE_PROFILE_DATA = gql`
  mutation UpdateProfileData($input: UpdateProfileDataInput!) {
    updateProfileData(input: $input) {
      firstname
      lastname
      telephone
      company
    }
  }
`;
